import AddFreeworkshop from './AddFreeworkshop';

export default AddFreeworkshop;
